// extracted by mini-css-extract-plugin
export default {"container":"notification_container__i3rGK","header":"notification_header__qWQo4","line":"notification_line__jSY1n","collapse__box":"notification_collapse__box__iaZGX"};